import { SessionStorageService } from './../../../shared/services/session-storage.service';
import { Component, OnInit, ElementRef, ViewChild, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { FormularioBase } from 'src/app/shared/pages/FormularioBase';
import { MasterService } from 'src/app/shared/services/master.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr'
import { AdministracionService } from 'src/app/shared/services/administracion.service';
import { ListItem } from 'src/app/shared/models/base/ListItem';
import { FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { debounceTime, tap, switchMap, finalize } from 'rxjs/operators';
import { Constantes } from 'src/app/shared/utils/Constantes';
import { EMaestro } from 'src/app/shared/models/entidades/EMaestro';
import { EParametrosGenerales } from 'src/app/shared/models/entidades/EParametrosGenerales';
import { ComunicacionService } from 'src/app/shared/services/comunicacionService.service';
import { MaestroDocumentoInternoService } from 'src/app/shared/services/maestro-documento-interno.service';
import { EUsuario } from 'src/app/shared/models/entidades/EUsuario';
import { Lookup } from 'src/app/shared/models/base/Lookup';
import { EComunicacionAdjuntoRegistrarDto } from 'src/app/shared/models/entidades/EComunicacionAdjuntoRegistrarDto';
import { environment } from 'src/environments/environment';
import * as $ from 'jquery';
import { Funciones } from 'src/app/shared/utils/Funciones';
import { ERegistrarComunicacionExternaDto } from 'src/app/shared/models/request/ERegistrarComunicacionExternaDto';
import { Deferred } from 'ts-deferred';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { ETipoDocumento } from 'src/app/shared/models/entidades/ETipoDocumento';
import { EHorarioRecepcionMPV } from 'src/app/shared/models/entidades/EHorarioRecepcionMPV';
import { EProyecto } from 'src/app/shared/models/entidades/EProyecto';

@Component({
  selector: 'app-nuevo-registro',
  templateUrl: './nuevo-registro.component.html',
  styleUrls: ['./nuevo-registro.component.css']
})
export class NuevoRegistroComponent extends FormularioBase implements OnInit {

  public ResetRecaptcha: boolean = false;
  public Token: string = environment.recaptchaSiteKey;
  public RecaptchaResolvedResponse!: string;
  public MostrarErrorRecaptcha: boolean = false;
  public IsCargando: boolean = true;
  public IsLoadingAutoComplete: boolean = false;
  public ItemsTipoDocumentoIdentidad: EMaestro[] = [];
  public ItemsTipoDocumento: EMaestro[] = [];
  public ItemsPaisRemitente: EMaestro[] = [];
  public ItemsSede: EMaestro[] = [];
  public ItemsFiltradosDestinatario: EUsuario[] = [];
  public ItemsAdjuntos: EComunicacionAdjuntoRegistrarDto[] = [];
  public ItemsHorarioRecepcionMPV: EHorarioRecepcionMPV[] = [];
  public ItemsProyecto: EProyecto[] = [];

  public mostrarCamposPN: boolean = false;
  public mostrarCamposPJ: boolean = true;

  public mostrarCampoAeropuertoDestino: boolean = false;

  public longitudTipoDocumentoIdentidad: number = 0;
  public longitudPersonaJuridica: number = 11;
  public numeroDocumentoPersonaJuridica = '';
  public tipoDocumentoPersonaJuridica: number = 0;
  public nombreTipoDocumentoPersonaJuridica = '';
  public abreviaturaEmpresa = '';
  public idEmpresa = 0;
  public idPais = 0;
  public nombreEmpresa = '';
  public urlLogoEmpresa = '';
  public disclaimer: string = '';
  public autorizacionDatos: string = '';
  public TextoExtensionesValidas = 'pdf,xls,xlsx,doc,docx,ppt,dwg,jpg,png,mp4,mp3,rar,zip';
  public textoInformativo = '';

  public mostrarSeccionDestinatario: boolean = false;
  public MostrarSwitchDocumentacionTecnica = false;
  public SwitchVaRegistrarDocumentacion = false;

  urlLogo: string = "";
  language: string = 'es';
  languageFlag: string = 'peru-bandera';

  tieneCargadoCarta = false;
  tieneCargadoHRD = false;
  nombreArchivoCarta = '';
  nombreArchivoHRD = '';

  disabledCarta = true;
  disabledHRD = true;

  public campo: any = {
    idRemitenteExterno: 0,
    destinatarioBuscar: "",
    destinatario: new EUsuario(),
    destinatariocompleto: "",
    area: new Lookup(),
    sede: new Lookup(),
    puesto: new Lookup()
  }

  public ItemJuridica: EMaestro = new EMaestro();

  nombreControles = {
    tipoRemitente: 'tipoRemitente',
    tipoDocumentoRemitente: 'tipoDocumentoRemitente',
    numeroDocumentoRemitente: 'numeroDocumentoRemitente',
    nombresRemitente: 'nombresRemitente',
    apellidoPaternoRemitente: 'apellidoPaternoRemitente',
    apellidoMaternoRemitente: 'apellidoMaternoRemitente',
    paisRemitente: 'paisRemitente',
    rucRemitente: 'rucRemitente',
    razonSocialRemitente: 'razonSocialRemitente',
    contactoRemitente: 'contactoRemitente',
    correoElectronicoRemitente: 'correoElectronicoRemitente',
    telefonoContactoRemitente: 'telefonoContactoRemitente',

    tipoDestino: 'tipoDestino',
    aeropuertoDestino: 'aeropuertoDestino',
    destinatario: 'destinatario',
    area: 'area',
    sede: 'sede',

    asunto: 'asunto',
    referencia: 'referencia',

    aplicaDestinatario: 'aplicaDestinatario',
    autorizacion: 'autorizacion',

    
    proyecto: 'proyecto',
    numeroSecuencia: 'numeroSecuencia',    
    titulo: 'titulo'
  };

  constructor(
    @Inject(I18NEXT_SERVICE) private i18NextService: ITranslationService,
    public dialog: MatDialog,
    public route: ActivatedRoute,
    public router: Router,
    public spinner: NgxSpinnerService,
    public utilService: UtilService,
    public administracionService: AdministracionService,
    public masterService: MasterService,
    public formBuilder: FormBuilder,
    public comunicacionService: ComunicacionService,
    public maestroDocumentoInternoService: MaestroDocumentoInternoService,
    private toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    super('nuevo-registro', dialog, route, router, spinner, utilService, masterService);

    this.form = this.formBuilder.group({
      tipoRemitente: ['Jurídica', Validators.required],
      tipoDocumentoRemitente: ['', Validators.required],
      numeroDocumentoRemitente: ['', Validators.required],
      nombresRemitente: ['', Validators.required],
      apellidoPaternoRemitente: ['', Validators.required],
      apellidoMaternoRemitente: ['', Validators.required],
      paisRemitente: ['1'],
      rucRemitente: ['', Validators.required],
      razonSocialRemitente: ['', Validators.required],
      contactoRemitente: [''],
      correoElectronicoRemitente: ['', Validators.email],
      telefonoContactoRemitente: [''],

      tipoDestino: [''],
      aeropuertoDestino: [''],
      destinatario: [{ value: '', disabled: true }, Validators.required],
      area: [{ value: '', disabled: true }, Validators.required],
      sede: [{ value: '', disabled: true }, Validators.required],

      asunto: ['', Validators.required],
      referencia: [''],

      aplicaDestinatario: false,
      autorizacion: false,

      proyecto: [''],
      numeroSecuencia: [
        '', // Valor inicial (puede ser null o un número como 0)
        [
          //Validators.required, // Si el campo es obligatorio
          Validators.min(0),   // Valor mínimo permitido
          Validators.max(100), // Valor máximo permitido
          Validators.pattern(/^[0-9]*$/) // ✨ Opcional: Para permitir solo números enteros sin decimales
        ]
      ],//['', Validators.required, Validators.min(1), Validators.max(999999)],
      titulo: ['']
    });
  }

  ngOnInit(): void {
    this.InicializarControles();
  }

  InicializarControles() {

    this.mostrarProgreso();
    this.ObtenerData();

    /*this.i18NextService.events.initialized.subscribe((e) => {
      if (e) {
        this.updateState(this.i18NextService.language);
      }
    });*/
  }

  obtenerParametro(parametro: string): any {
    const valor = this.route.snapshot.queryParams[parametro];

    if (!valor) {
      return 0;
    }

    return valor;
  }

  ObtenerData() {

    const lng = "es";
    /*if (lng == 0) {
      const url = window.location.origin + "/?lng=es";
      window.location.href = url;
    }*/

    const emp = "3";//this.obtenerParametro('emp');

    /*if (emp == 0) {
      const lngVal = this.obtenerParametro('lng');
      let textoError = '';

      if (lngVal === 'es') {
        textoError = 'El enlace de la pagina no cuenta con el identificador de la empresa';
      }
      else {
        textoError = 'The page link does not have the company identifier';
      }

      sessionStorage.setItem('SesionRegistroPublico_MensajeError', textoError);
      const url = window.location.origin + "/error";
      window.location.href = url;
    }*/

    this.sessionStorageService.IdEmpresa = parseInt(emp);

    Promise.all([
      this.maestroDocumentoInternoService.obtenerMaestros("AdmPais", ""),
      this.maestroDocumentoInternoService.filtrarMaestroTipoDocumentos(),
      this.maestroDocumentoInternoService.obtenerMaestros("AdmParametrosGenerales", "Tipo de documento"),
      this.maestroDocumentoInternoService.obtenerEmpresa(emp),
      this.maestroDocumentoInternoService.obtenerMaestros("AdmSede", ""),
      this.maestroDocumentoInternoService.obtenerHorariosRecepcionMPV(emp)])
      .then(([elementosPais, elementosTipoDocumentoIdentidad, elementosTipoDocumento, elementoEmpresa, elementosSede, elementosHorariosRecepcionMPV]) => {

        const lngVal = lng;
        if (elementoEmpresa.data.id === 0) {

          let textoError = '';

          if (lngVal === 'es') {
            textoError = 'El identificador de la empresa no es un dato valido';
          }
          else {
            textoError = 'The company identifier is not a valid data';
          }

          sessionStorage.setItem('SesionRegistroPublico_MensajeError', textoError);
          const url = window.location.origin + "/error";
          window.location.href = url;
        }
        else {

          this.idEmpresa = elementoEmpresa.data.id;
          this.idPais = elementoEmpresa.data.pais.id;
          this.nombreEmpresa = elementoEmpresa.data.title;
          this.urlLogoEmpresa = elementoEmpresa.data.urlLogo;
          this.urlLogo = elementoEmpresa.data.urlLogo;
          this.abreviaturaEmpresa = elementoEmpresa.data.abreviatura;
          this.disclaimer = lngVal === 'es'
            ? elementoEmpresa.data.disclaimerMesaPartes
            : elementoEmpresa.data.disclaimerMesaPartes;
          this.autorizacionDatos = lngVal === 'es'
            ? elementoEmpresa.data.autorizacionDatosPersonales
            : elementoEmpresa.data.autorizacionDatosPersonales;
        }

        const elementoJuridica = elementosTipoDocumentoIdentidad.data.filter((elemento: any) => {
          return elemento.title === 'RUC';
        });

        this.ItemsSede = EMaestro.parseJsonListBack(elementosSede.data, lng);

        this.ItemsTipoDocumento = EMaestro.parseJsonListBack(elementosTipoDocumento.data, lng);
        const ItemsTipoDocumentoIdentidad = EMaestro.parseJsonListBack(elementosTipoDocumentoIdentidad.data, lng);

        if (elementoJuridica.length !== 0) {
          this.ItemJuridica = EMaestro.parseJsonBack(elementoJuridica[0]);

          this.longitudPersonaJuridica = 11;
          this.nombreTipoDocumentoPersonaJuridica = this.ItemJuridica.Title;
          this.tipoDocumentoPersonaJuridica = parseInt(this.ItemJuridica.ID, 10);

          this.ItemsTipoDocumentoIdentidad = ItemsTipoDocumentoIdentidad.filter((elemento: EMaestro) => {
            return elemento.ID !== this.ItemJuridica.ID;
          });
        }

        var days = ["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"];
        const dia = days[new Date().getDay()];
        console.dir(dia);
        this.ItemsHorarioRecepcionMPV = EHorarioRecepcionMPV.parseJsonListBack(elementosHorariosRecepcionMPV.data, lng);
        const elementoHorario = this.ItemsHorarioRecepcionMPV.filter(x => x.Dia === dia);

        console.dir(elementoHorario);

        if (elementoHorario.length !== 0) {
          const noHayAtencion = elementoHorario[0].NoHayAtencion;
          const horaInicio = elementoHorario[0].HoraInicio;
          const horaFin = elementoHorario[0].HoraFin;

          if (!noHayAtencion) {
            this.textoInformativo = 'Hoy ' + dia.toLocaleUpperCase() + ' el horario de recepción de documentos es de ' + horaInicio + ' a ' + horaFin + ' horas, de registrarse posteriormente el documento, se considerará la fecha de recepción el próximo día útil a primera hora de atención.';
          }
          else {
            this.textoInformativo = 'Hoy ' + dia.toLocaleUpperCase() + ' no hay recepción de documentos, de proceder con el registro del documento, se considerará la fecha de recepción el próximo día útil de atención a primera hora';
          }
        }

        this.ItemsPaisRemitente = EMaestro.parseJsonListBack(elementosPais.data, lng);
        this.ocultarProgreso();

      })
      .catch(error => {
        this.ocultarProgreso();
        console.dir('Error: ' + error);
      });

    this.form.controls[this.nombreControles.tipoDocumentoRemitente].disable();
    this.form.controls[this.nombreControles.numeroDocumentoRemitente].disable();
    this.form.controls[this.nombreControles.nombresRemitente].disable();
    this.form.controls[this.nombreControles.apellidoPaternoRemitente].disable();
    this.form.controls[this.nombreControles.apellidoMaternoRemitente].disable();

    this.form.controls[this.nombreControles.paisRemitente].enable();
    this.form.controls[this.nombreControles.rucRemitente].enable();
    this.form.controls[this.nombreControles.razonSocialRemitente].disable();
  }

  get primaryEmail() {
    return this.form.get(this.nombreControles.correoElectronicoRemitente);
  }

  onClickCambiarIdioma(idioma: string): void {
    const url = window.location.origin + "/?lng=" + idioma;
    window.location.href = url;
  }

  onChangeTipoRemitente(event: any): void {
    const valor = event.value;//this.getValorControlString(this.nombreControles.tipoRemitente);
    if (valor === "Natural") {
      this.form.controls[this.nombreControles.tipoDocumentoRemitente].enable();
      this.form.controls[this.nombreControles.numeroDocumentoRemitente].enable();
      this.form.controls[this.nombreControles.nombresRemitente].disable();
      this.form.controls[this.nombreControles.apellidoPaternoRemitente].disable();
      this.form.controls[this.nombreControles.apellidoMaternoRemitente].disable();

      this.form.controls[this.nombreControles.paisRemitente]?.setValue('');
      this.form.controls[this.nombreControles.rucRemitente]?.setValue('');
      this.form.controls[this.nombreControles.razonSocialRemitente]?.setValue('');
      this.form.controls[this.nombreControles.paisRemitente].disable();
      this.form.controls[this.nombreControles.rucRemitente].disable();
      this.form.controls[this.nombreControles.razonSocialRemitente].disable();

      /*this.form.controls[this.nombreControles.paisRemitente].updateValueAndValidity();
      this.form.controls[this.nombreControles.rucRemitente].updateValueAndValidity();
      this.form.controls[this.nombreControles.razonSocialRemitente].updateValueAndValidity();*/

      this.mostrarCamposPN = true;
      this.mostrarCamposPJ = false;
    } else if (valor === "Jurídica") {
      this.form.controls[this.nombreControles.paisRemitente].enable();
      this.form.controls[this.nombreControles.rucRemitente].enable();
      this.form.controls[this.nombreControles.razonSocialRemitente].disable();

      this.form.controls[this.nombreControles.paisRemitente]?.setValue('1');
      this.form.controls[this.nombreControles.tipoDocumentoRemitente].disable();
      this.form.controls[this.nombreControles.numeroDocumentoRemitente].disable();
      this.form.controls[this.nombreControles.nombresRemitente].disable();
      this.form.controls[this.nombreControles.apellidoPaternoRemitente].disable();
      this.form.controls[this.nombreControles.apellidoMaternoRemitente].disable();

      this.form.controls[this.nombreControles.tipoDocumentoRemitente].setValue('');
      this.form.controls[this.nombreControles.numeroDocumentoRemitente].setValue('');
      this.form.controls[this.nombreControles.nombresRemitente].setValue('');
      this.form.controls[this.nombreControles.apellidoPaternoRemitente].setValue('');
      this.form.controls[this.nombreControles.apellidoMaternoRemitente].setValue('');

      /*this.form.controls[this.nombreControles.paisRemitente].updateValueAndValidity();
      this.form.controls[this.nombreControles.rucRemitente].updateValueAndValidity();
      this.form.controls[this.nombreControles.razonSocialRemitente].updateValueAndValidity();
      this.form.controls[this.nombreControles.paisRemitente].updateValueAndValidity();
      this.form.controls[this.nombreControles.rucRemitente].updateValueAndValidity();*/

      this.mostrarCamposPN = false;
      this.mostrarCamposPJ = true;
    }
  }

  eventoSeleccionarTipoDocumento(item: EMaestro): void {
    this.longitudTipoDocumentoIdentidad = item.Longitud;
    this.form.controls[this.nombreControles.numeroDocumentoRemitente].setValue('');
    this.form.controls[this.nombreControles.rucRemitente].setValue('');
  }

  eventoSeleccionarPais(item: EMaestro): void {

    this.form.controls[this.nombreControles.rucRemitente].setValue('');
    if (item.Title.toUpperCase() === "PERÚ" || item.Title.toUpperCase() === "PERU") {
      this.longitudPersonaJuridica = 11;
    } else {
      this.longitudPersonaJuridica = this.ItemJuridica.Longitud;
    }
  }

  onSeleccionTipoDestino(event: any): void {
    const tipoDestino = this.form.get(this.nombreControles.tipoDestino)?.value;

    this.form.get(this.nombreControles.aeropuertoDestino)?.setValue(null);

    if (tipoDestino === "Aeropuerto") {
      this.mostrarCampoAeropuertoDestino = true
      this.form.controls[this.nombreControles.aeropuertoDestino].validator = Validators.required;
    }
    else {
      this.mostrarCampoAeropuertoDestino = false
      this.form.controls[this.nombreControles.aeropuertoDestino].clearValidators();
    }

    this.form.controls[this.nombreControles.aeropuertoDestino].updateValueAndValidity();
    
    this.form.get(this.nombreControles.aplicaDestinatario)?.setValue(false);
    this.mostrarSeccionDestinatario = false;
    this.campo.destinatarioBuscar = "";
    this.campo.destinatario = new EUsuario();
    this.campo.destinatariocompleto = "";
    this.campo.sede = new Lookup();
    this.campo.area = new Lookup();
    this.campo.puesto = new Lookup();
    this.form.controls[this.nombreControles.destinatario].setValue('');
    this.form.controls[this.nombreControles.sede].setValue('');
    this.form.controls[this.nombreControles.area].setValue('');
    this.form.controls[this.nombreControles.destinatario].disable();
    this.form.controls[this.nombreControles.sede].disable();
    this.form.controls[this.nombreControles.area].disable();
  }

  onChangeAplicaDestinatario(event: any): void {

    const valor = event.checked;

    if (valor) {

      this.mostrarSeccionDestinatario = true;
      this.form.controls[this.nombreControles.destinatario].enable();
      this.form.controls[this.nombreControles.sede].enable();
      this.form.controls[this.nombreControles.area].enable();

    } else {

      this.mostrarSeccionDestinatario = false;
      this.campo.destinatarioBuscar = "";
      this.campo.destinatario = new EUsuario();
      this.campo.destinatariocompleto = "";
      this.campo.sede = new Lookup();
      this.campo.area = new Lookup();
      this.campo.puesto = new Lookup();
      this.form.controls[this.nombreControles.destinatario].setValue('');
      this.form.controls[this.nombreControles.sede].setValue('');
      this.form.controls[this.nombreControles.area].setValue('');
      this.form.controls[this.nombreControles.destinatario].disable();
      this.form.controls[this.nombreControles.sede].disable();
      this.form.controls[this.nombreControles.area].disable();
    }
    
    this.mostrarCampoAeropuertoDestino = false;
    this.form.get(this.nombreControles.tipoDestino)?.setValue('');
    this.form.get(this.nombreControles.aeropuertoDestino)?.setValue(null);
    this.form.controls[this.nombreControles.aeropuertoDestino].clearValidators();
    this.form.controls[this.nombreControles.aeropuertoDestino].updateValueAndValidity();
  }

  onClickValidarRemitente(): void {

    const tipoPersona = this.getValorControlString(this.nombreControles.tipoRemitente);
    const datos: any = {};
    datos.TipoPersona = tipoPersona
    datos.IdPais = 1;
    datos.IdEmpresa = this.idEmpresa;

    let faltanDatos = false;

    if (tipoPersona === 'Natural') {
      datos.NumeroDocumento = this.getValorControlString(this.nombreControles.numeroDocumentoRemitente);
      datos.IdTipoDocumento = this.getValorControlNumber(this.nombreControles.tipoDocumentoRemitente);

      const elementoTipoDocumento = this.ItemsTipoDocumentoIdentidad.filter(x => x.ID === datos.IdTipoDocumento.toString());

      if (elementoTipoDocumento.length !== 0) {
        datos.TipoDocumento = elementoTipoDocumento[0].Title;
      }

      if (datos.IdTipoDocumento === 0) {
        this.toastr.warning(this.language === 'es' ? "Seleccione el tipo de documento" : "Select the type of document", this.language === "es" ? "¡Validación!" : "Validation!");
        faltanDatos = true;
      }

      if (Funciones.esUndefinedNullOrEmpty(datos.NumeroDocumento)) {
        this.toastr.warning(this.language === 'es' ? "Ingrese el número de documento" : "Enter the document number", this.language === "es" ? "¡Validación!" : "Validation!");
        faltanDatos = true;
      }
    }
    else {
      datos.NumeroDocumento = this.getValorControlString(this.nombreControles.rucRemitente);
      datos.IdTipoDocumento = this.tipoDocumentoPersonaJuridica;
      datos.TipoDocumento = this.nombreTipoDocumentoPersonaJuridica;
      //datos.IdPais = this.getValorControlNumber(this.nombreControles.paisRemitente);

      if (datos.IdPais === 0) {
        this.toastr.warning(this.language === 'es' ? "Seleccione el país" : "Select country", this.language === "es" ? "¡Validación!" : "Validation!");
        faltanDatos = true;
      }

      if (Funciones.esUndefinedNullOrEmpty(datos.NumeroDocumento)) {
        this.toastr.warning(this.language === 'es' ? "Ingrese el número de documento" : "Enter the document number", this.language === "es" ? "¡Validación!" : "Validation!");
        faltanDatos = true;
      }
    }

    if (faltanDatos) {
      return;
    }

    this.mostrarProgreso();

    this.maestroDocumentoInternoService.buscarRemitente(datos)
      .then((result: any) => {
        console.dir(result);

        this.ocultarProgreso();

        if (result.data.id !== 0) {
          this.campo.idRemitenteExterno = result.data.id;
          this.MostrarSwitchDocumentacionTecnica = result.data.puedeRegistrarInfoTecnica;
          if (tipoPersona === 'Natural') {
            this.form.get(this.nombreControles.nombresRemitente)?.setValue(result.data.nombres);
            this.form.get(this.nombreControles.apellidoPaternoRemitente)?.setValue(result.data.apellidoPaterno);
            this.form.get(this.nombreControles.apellidoMaternoRemitente)?.setValue(result.data.apellidoMaterno);
          }
          else {
            this.form.get(this.nombreControles.razonSocialRemitente)?.setValue(result.data.nombreEntidad);
          }
          console.dir(result.data);
        } else {

          // this.toastr.warning('No se encontró un remitente con los datos ingresados', '¡Informativo!');
          this.toastr.warning(this.language === 'es' ? "No se encontró un remitente con los datos ingresados" : "No sender found with the entered data", this.language === "es" ? "¡Informativo!" : "Informative!");

          this.campo.idRemitenteExterno = 0;
          if (tipoPersona === 'Natural') {
            this.form.get(this.nombreControles.nombresRemitente)?.setValue('');
            this.form.get(this.nombreControles.apellidoPaternoRemitente)?.setValue('');
            this.form.get(this.nombreControles.apellidoMaternoRemitente)?.setValue('');

            this.form.controls[this.nombreControles.nombresRemitente].enable();
            this.form.controls[this.nombreControles.apellidoPaternoRemitente].enable();
            this.form.controls[this.nombreControles.apellidoMaternoRemitente].enable();
          }
          else {
            this.form.get(this.nombreControles.razonSocialRemitente)?.setValue('');
            this.form.controls[this.nombreControles.razonSocialRemitente].enable();
          }

        }
      })
      .catch((error: any) => {
        this.mostrarModalError('Error Buscar Remitente: ', error.message);
        this.ocultarProgreso();
      });
  }

  async eventoFiltrarDestinatario() {
    this.IsLoadingAutoComplete = true;
    const itemsFiltradosDestinatario = [];

    const textoBusqueda = this.getValorControlString(this.nombreControles.destinatario);

    // const Items = await this.maestroDocumentoInternoService.filtrarMaestroUsuarios(this.campo.destinatarioBuscar);
    const Items = await this.maestroDocumentoInternoService.filtrarMaestroUsuarios(textoBusqueda);

    if (Items.data.length > 0) {
      for (const item of Items.data) {
        itemsFiltradosDestinatario.push(EUsuario.parseJsonBack(item));
      }
    }

    console.dir(this.ItemsFiltradosDestinatario);
    this.ItemsFiltradosDestinatario = itemsFiltradosDestinatario;

    this.IsLoadingAutoComplete = false;
  }

  eventoSeleccionarDestinatario(destinantario: EUsuario): void {

    this.campo.destinatarioBuscar = destinantario.Usuario.Name;
    this.campo.destinatariocompleto = destinantario;
    this.campo.destinatario = destinantario.Usuario;
    this.campo.sede = destinantario.Sede;
    this.campo.area = destinantario.Area;
    this.campo.puesto = destinantario.Puesto;

    const lng = 'es';

    if (lng === "es") {
      this.form.get(this.nombreControles.sede)?.setValue(this.campo.sede.Title);
      this.form.get(this.nombreControles.area)?.setValue(this.campo.area.Title);
    } else {
      this.form.get(this.nombreControles.sede)?.setValue(this.campo.sede.TitleEN);
      this.form.get(this.nombreControles.area)?.setValue(this.campo.area.TitleEN);
    }
  }

  async OnFileUploadDocumentosAdjuntos(event: any): Promise<any> {

    if (event.target.files.length > 0) {

      const files = event.target.files;
      const listaArchivosRepetidos = [];
      const listaArchivosTamanoNoPermitidos = [];
      const listaArchivosExtensionesNoPermitidas = [];
      const listaArchivosContenidoErroneo = [];

      for (let i = 0; i < files.length; i++) {
        const archivo = files[i];

        const archivoRepetido = this.ItemsAdjuntos.filter(d => d.NombreArchivo === archivo.name);

        if (archivoRepetido.length > 0) {
          listaArchivosRepetidos.push(archivo.name);
        }

        if (!this.esArchivoExtensionValida(archivo.name)) {
          listaArchivosExtensionesNoPermitidas.push(archivo);
        }

        if (archivo.size > 209715200) {
          listaArchivosTamanoNoPermitidos.push(archivo.name);
        }

        if (await this.validarArchivoEncriptado(archivo).then()) {
          listaArchivosContenidoErroneo.push(archivo.name);
        }
      }

      if (listaArchivosRepetidos.length > 0) {
        const nombreArchivosRepetidos = listaArchivosRepetidos.join(', ');
        let mensaje = '';

        if (this.language === "en") {
          mensaje = 'The following files are repeated: ' + nombreArchivosRepetidos;
        } else {
          mensaje = 'Los siguientes archivos están repetidos: ' + nombreArchivosRepetidos;
        }

        this.mostrarModalInformativo('¡Validación!', mensaje);

        $('#FileControlDocumentosAdjuntos').val('');
        return;
      }

      if (listaArchivosContenidoErroneo.length > 0) {
        const nombreArchivosContenidoErroneo = listaArchivosContenidoErroneo.join(', ');
        let mensaje = '';

        if (this.language === "en") {
          mensaje = 'The following encrypted PDF files are not allowed: ' + nombreArchivosContenidoErroneo;
        } else {
          mensaje = 'Los siguientes archivos PDF encriptados no estan permitidos: ' + nombreArchivosContenidoErroneo;
        }

        this.mostrarModalInformativo('¡Validación!', mensaje);

        $('#FileControlDocumentosAdjuntos').val('');
        return;
      }

      if (listaArchivosExtensionesNoPermitidas.length > 0) {
        //const nombreArchivosExtensionNoPermitidas = listaArchivosExtensionesNoPermitidas.join(', ');
        let mensaje = '';

        if (this.language === "en") {
          mensaje = 'Only files with the following extensions are allowed: .pdf,.xls,.xlsx,.doc,.docx,.ppt,.dwg,.jpg,.png,.mp4,.mp3,.rar,.zip';
        } else {
          mensaje = 'Sólo se permiten archivos con las siguientes extensiones: .pdf,.xls,.xlsx,.doc,.docx,.ppt,.dwg,.jpg,.png,.mp4,.mp3,.rar,.zip';
        }
        this.mostrarModalInformativo('¡Validación!', mensaje);

        $('#FileControlDocumentosAdjuntos').val('');
        return;
      }

      if (listaArchivosTamanoNoPermitidos.length > 0) {
        const nombreArchivosTamanoNoPermitidos = listaArchivosTamanoNoPermitidos.join(', ');
        let mensaje = '';

        if (this.language === "en") {
          mensaje = 'The following files exceed the maximum size of 50 MB: ' + nombreArchivosTamanoNoPermitidos;
        } else {
          mensaje = 'Los siguientes archivos superan el peso máximo de 50 MB: ' + nombreArchivosTamanoNoPermitidos;
        }
        this.mostrarModalInformativo('¡Validación!', mensaje);

        $('#FileControlDocumentosAdjuntos').val('');
        return;
      }

      this.mostrarProgreso();

      for (let i = 0; i < files.length; i++) {

        this.convertirArrayByte(files[i]).then((resultByteArchivo: any) => {
          const byteArchivo: any = resultByteArchivo;

          const datosArchivo: EComunicacionAdjuntoRegistrarDto = {
            EsPrincipal: false,
            NombreArchivo: this.reemplazarNombreArchivo(files[i].name),
            Codigo: '',
            Tipo: '0',
            Descripcion: '',
            Archivo: byteArchivo
          };

          this.ItemsAdjuntos.push(datosArchivo);
          this.ocultarProgreso();
        })
      }

      $('#FileControlDocumentosAdjuntos').val('');

    }
  }

  reemplazarNombreArchivo(nombreArchivo: string): string {
    let fileName = nombreArchivo.slice(0, nombreArchivo.lastIndexOf('.'));
    fileName = this.replaceUnsupportedCharacters(fileName);
    const extension = nombreArchivo.substr(nombreArchivo.lastIndexOf('.') + 1, nombreArchivo.length);
    return fileName + '.' + extension;
  }

  public replaceUnsupportedCharacters(fileName: string): string {
    fileName = fileName.replace("#", "");
    fileName = fileName.replace("%", "");
    fileName = fileName.replace("&", "");
    fileName = fileName.replace("*", "");
    fileName = fileName.replace(":", "");
    fileName = fileName.replace("<", "");
    fileName = fileName.replace(">", "");
    fileName = fileName.replace("?", "");
    fileName = fileName.replace("/", "");
    fileName = fileName.replace("{", "");
    fileName = fileName.replace("|", "");
    fileName = fileName.replace("}", "");
    fileName = fileName.replace("~", "");
    fileName = fileName.replace("\\", "");
    fileName = fileName.replace('"', "");
    fileName = fileName.replace("'", "");
    fileName = fileName.replace("á", "a");
    fileName = fileName.replace("é", "e");
    fileName = fileName.replace("í", "i");
    fileName = fileName.replace("ó", "o");
    fileName = fileName.replace("ú", "u");
    fileName = fileName.replace("Á", "A");
    fileName = fileName.replace("É", "E");
    fileName = fileName.replace("Í", "I");
    fileName = fileName.replace("Ó", "O");
    fileName = fileName.replace("Ú", "U");
    return fileName;
  }

  private esArchivoExtensionValida = (nombreArchivo: string): boolean => {
    const extensionArchivo = this.getExtensionArchivo(nombreArchivo);

    const esExtensionNoPermitida = (this.TextoExtensionesValidas.split(',').filter((extension: string) => {
      return extension.trim().toUpperCase() === extensionArchivo.toUpperCase();
    }));

    return esExtensionNoPermitida.length > 0;
  }

  private getExtensionArchivo = (nombreArchivo: string): string => {
    const archivoSplit = nombreArchivo.split('.');
    const extensionArchivo = archivoSplit[archivoSplit.length - 1];

    return extensionArchivo;
  }

  async validarArchivoEncriptado(file: any): Promise<any> {
    const d: Deferred<any> = new Deferred<any>();

    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = function () {

      if (reader.result != null) {
        var files2 = new Blob([reader.result], { type: 'application/pdf' });
        files2.text().then(x => {
          let estaEncriptado = x.includes("Encrypt") || x.substring(x.lastIndexOf("<<"), x.lastIndexOf(">>")).includes("/Encrypt");
          d.resolve(estaEncriptado);
        });
      } else {
        d.resolve(false);
      }
    }

    return d.promise;
  }

  OnEliminarAdjunto(item: EComunicacionAdjuntoRegistrarDto): void {
    this.ItemsAdjuntos = this.ItemsAdjuntos.filter((elemento: EComunicacionAdjuntoRegistrarDto) => {
      return elemento.NombreArchivo !== item.NombreArchivo;
    });
  }

  onChangeAdjuntoEsPrincipal(item: EComunicacionAdjuntoRegistrarDto, event: any): void {

    for (let i = 0; i < this.ItemsAdjuntos.length; i++) {
      this.ItemsAdjuntos[i].EsPrincipal = false;

      if (this.ItemsAdjuntos[i].NombreArchivo === item.NombreArchivo) {
        this.ItemsAdjuntos[i].EsPrincipal = true;
      }
    }
  }

  onChangeAdjuntoCodigo(item: EComunicacionAdjuntoRegistrarDto, event: any): void {

    for (let i = 0; i < this.ItemsAdjuntos.length; i++) {

      if (this.ItemsAdjuntos[i].NombreArchivo === item.NombreArchivo) {
        this.ItemsAdjuntos[i].Codigo = event.target.value;
      }
    }
  }

  onChangeAdjuntoTipo(item: EComunicacionAdjuntoRegistrarDto, event: any): void {

    for (let i = 0; i < this.ItemsAdjuntos.length; i++) {

      if (this.ItemsAdjuntos[i].NombreArchivo === item.NombreArchivo) {
        const elementoTipo = this.ItemsTipoDocumento.filter((elemento: EMaestro) => {
          return elemento.Title === event.target.innerText;
        });

        if (elementoTipo.length > 0) {
          this.ItemsAdjuntos[i].Tipo = elementoTipo[0].ID;
        }
      }
    }
  }

  onChangeAdjuntoDescripcion(item: EComunicacionAdjuntoRegistrarDto, event: any): void {

    for (let i = 0; i < this.ItemsAdjuntos.length; i++) {

      if (this.ItemsAdjuntos[i].NombreArchivo === item.NombreArchivo) {
        this.ItemsAdjuntos[i].Descripcion = event.target.value;
      }
    }
  }

  getJsonElementoComunicacion(): any {

    const datos: ERegistrarComunicacionExternaDto = new ERegistrarComunicacionExternaDto();

    datos.IdPais = this.idPais;
    datos.IdEmpresa = this.idEmpresa;
    datos.AbreviaturaEmpresa = this.abreviaturaEmpresa;

    const documentoPrincipal = this.ItemsAdjuntos.filter((elemento: EComunicacionAdjuntoRegistrarDto) => {
      return elemento.EsPrincipal;
    });

    datos.TipoComunicacion = 'E';
    datos.TipoRemitente = this.getValorControlString(this.nombreControles.tipoRemitente);
    datos.IdRemitenteExterno = this.campo.idRemitenteExterno;

    if (datos.TipoRemitente === "Natural") {
      datos.IdTipoDocumentoRemitente = this.getValorControlNumber(this.nombreControles.tipoDocumentoRemitente);
    }
    else {
      datos.IdTipoDocumentoRemitente = this.tipoDocumentoPersonaJuridica;
    }

    const tipoDestino = this.form.get(this.nombreControles.tipoDestino)?.value;

    if (!Funciones.EsNullVacioUndefined(tipoDestino)) {

      datos.TipoDestino = this.getValorControlString(this.nombreControles.tipoDestino);

      if (this.mostrarCampoAeropuertoDestino) {
        datos.IdAeropuertoDestino = this.form.get(this.nombreControles.aeropuertoDestino)?.value;
      }
    }

    datos.NumeroDocumentoRemitente = this.getValorControlString(this.nombreControles.numeroDocumentoRemitente);
    datos.NombreRemitente = this.getValorControlString(this.nombreControles.nombresRemitente);
    datos.ApellidoPaternoRemitente = this.getValorControlString(this.nombreControles.apellidoPaternoRemitente);
    datos.ApellidoMaternoRemitente = this.getValorControlString(this.nombreControles.apellidoMaternoRemitente);
    datos.IdPaisRemitente = this.getValorControlNumber(this.nombreControles.paisRemitente);
    datos.RucRemitente = this.getValorControlString(this.nombreControles.rucRemitente);
    datos.RazonSocialRemitente = this.getValorControlString(this.nombreControles.razonSocialRemitente);
    datos.NombrePersonaContacto = this.getValorControlString(this.nombreControles.contactoRemitente);
    datos.CorreoPersonaContacto = this.getValorControlString(this.nombreControles.correoElectronicoRemitente);
    datos.TelefonoPersonaContacto = this.getValorControlString(this.nombreControles.telefonoContactoRemitente);

    datos.AplicaDestinatario = this.form.controls[this.nombreControles.aplicaDestinatario]?.value;

    if (this.mostrarSeccionDestinatario) {
      datos.IdDestinatarioInterno = this.campo.destinatariocompleto.ID;
      datos.IdDestinatarioInternoSharePoint = this.campo.destinatario.ID;
      datos.NombreUsuarioDestino = this.campo.destinatario.Name;
      datos.CorreoUsuarioDestino = this.campo.destinatario.Email;
      datos.IdAreaUsuarioDestino = this.campo.area.ID;
      datos.IdSedeUsuarioDestino = this.campo.sede.ID;
      datos.IdPuestoUsuarioDestino = this.campo.puesto.ID;
    }

    datos.Asunto = this.getValorControlString(this.nombreControles.asunto);
    datos.Referencia = this.getValorControlString(this.nombreControles.referencia);

    if (documentoPrincipal.length > 0) {
      datos.IdTipoDocumentoPrincipal = parseInt(documentoPrincipal[0].Tipo, 10);
      datos.NumeroDocumentoPrincipal = documentoPrincipal[0].Codigo;
      datos.TituloDocumentoPrincipal = documentoPrincipal[0].Descripcion;
    }

    const adjuntos: any[] = [];

    for (const ItemAdjunto of this.ItemsAdjuntos) {
      const adjunto = {
        NombreArchivo: ItemAdjunto.NombreArchivo,
        IdTipoDocumento: parseInt(ItemAdjunto.Tipo, 10),
        NumeroDocumento: ItemAdjunto.Codigo,
        Descripcion: ItemAdjunto.Descripcion,
        EsPrincipal: ItemAdjunto.EsPrincipal,
        Archivo: ItemAdjunto.Archivo
      };

      adjuntos.push(adjunto);
    }

    datos.AdjuntoComunicacion = adjuntos;

    datos.recaptchaToken = this.RecaptchaResolvedResponse;

    datos.VaRegistrarDocumentacionTecnica = false;
    datos.NumeroSecuencia = '0';

    if(this.SwitchVaRegistrarDocumentacion){
      datos.VaRegistrarDocumentacionTecnica = this.SwitchVaRegistrarDocumentacion;
      const proyectoId = this.getValorControlString(this.nombreControles.proyecto);
      const elementoProyecto = this.ItemsProyecto.filter(x => x.ID == proyectoId);
      datos.CodigoInternoProyecto = elementoProyecto.length > 0 ? elementoProyecto[0].CodigoInternoACC: "";
      datos.CodigoProyecto = elementoProyecto.length > 0 ? elementoProyecto[0].Codigo: "";
      datos.NombreProyecto = elementoProyecto.length > 0 ? elementoProyecto[0].Title: "";
      datos.NumeroSecuencia = this.getValorControlString(this.nombreControles.numeroSecuencia);
    }

    return datos;
  }

  public RecaptchaResolved(event: string): void {
    this.MostrarErrorRecaptcha = false;
    this.RecaptchaResolvedResponse = event;
  }

  onClickEnviar(): void {

    if (this.form.invalid) {
      if (this.language === "en") {
        this.toastr.warning('Enter the required fields.', 'Validation!');
      } else {
        this.toastr.warning('Ingrese los campos obligatorios.', '¡Validación!');
      }
      return;
    }

    const aplicaDestinatario = this.form.controls[this.nombreControles.aplicaDestinatario]?.value;
    const tipoDestino = this.form.get(this.nombreControles.tipoDestino)?.value;

    if (!aplicaDestinatario && Funciones.EsNullVacioUndefined(tipoDestino)) {
      this.toastr.warning('Debe seleccionar un destinatario.', '¡Validación!');
      return;
    }

    if (this.ItemsAdjuntos.length === 0  && !this.SwitchVaRegistrarDocumentacion) {
      if (this.language === "en") {
        this.toastr.warning('You must add at least one document.', 'Validation!');
      } else {
        this.toastr.warning('Debe agregar al menos un documento.', '¡Validación!');
      }
      return;
    }

    if (this.ItemsAdjuntos.length !== 0) {
      const elementoPrincipal = this.ItemsAdjuntos.filter((elemento: EComunicacionAdjuntoRegistrarDto) => {
        return elemento.EsPrincipal;
      });
  
      if (elementoPrincipal.length === 0) {
        if (this.language === "en") {
          this.toastr.warning('You must select a main document.', 'Validation!');
        } else {
          this.toastr.warning('Debe seleccionar un documento principal.', '¡Validación!');
        }
        return;
      }

      if (elementoPrincipal.length > 0) {
        if (elementoPrincipal[0].Tipo === '0') {
          if (this.language === "en") {
            this.toastr.warning('You must select a type to the main document.', 'Validation!');
          } else {
            this.toastr.warning('Debe seleccionar un tipo al documento principal.', '¡Validación!');
          }
          return;
        }
      }
    }    

    if(this.SwitchVaRegistrarDocumentacion){
      const elementoTipoCarta = this.ItemsTipoDocumento.filter((elemento: EMaestro) => { return elemento.Title === 'Carta'; });
      const elementoTipoHRD = this.ItemsTipoDocumento.filter((elemento: EMaestro) => { return elemento.Title === 'HRD'; });
      const IdCarta = elementoTipoCarta.length > 0 ? elementoTipoCarta[0].ID.toString(): '0'; 
      const IdHRD = elementoTipoHRD.length > 0 ? elementoTipoHRD[0].ID.toString(): '0';

      const tieneCarta = this.ItemsAdjuntos.filter(x => x.Tipo === IdCarta).length !== 0;
      const tieneHRD = this.ItemsAdjuntos.filter(x => x.Tipo === IdHRD).length !== 0;

      if(!tieneCarta || !tieneHRD){
        if (this.language === "en") {
          this.toastr.warning('You must add a Letter and an HRD.', 'Validation!');
        } else {
          this.toastr.warning('Debe agregar una Carta y un HRD.', '¡Validación!');
        }
        return;
      }
    }

    const autorizacion = this.form.get(this.nombreControles.autorizacion)?.value;

    if (!autorizacion) {
      if (this.language === "en") {
        this.toastr.warning('You must check the box to authorize the processing of your data.', 'Validation!');
      } else {
        this.toastr.warning('Debe marcar la casilla de autoización de tratamiento de sus datos.', '¡Validación!');
      }
      return;
    }

    if (!this.RecaptchaResolvedResponse) {
      if (this.language === "en") {
        this.toastr.warning('You must check the reCAPTCHA checkbox.', 'Validation!');
      } else {
        this.toastr.warning('Debe marcar la casilla de verificación de reCAPTCHA.', '¡Validación!');
      }
      this.MostrarErrorRecaptcha = true;
      return;
    }
    this.ResetRecaptcha = true;

    let mensajeConfirmacionGuardarComunicacion = "¿Esta seguro de guardar la comunicación?";
    if (this.language === "en") {
      mensajeConfirmacionGuardarComunicacion = "Are you sure to save the communication?";
    }

    if(this.SwitchVaRegistrarDocumentacion){
      const elementoTipo = this.ItemsTipoDocumento.filter((elemento: EMaestro) => {
        return elemento.Title === 'Carta';
      });  
      const IdCarta = elementoTipo.length > 0 ? elementoTipo[0].ID.toString(): '0';  
      for (let i = 0; i < this.ItemsAdjuntos.length; i++) {
        if (this.ItemsAdjuntos[i].Tipo === IdCarta) {
          this.ItemsAdjuntos[i].Descripcion = this.getValorControlString(this.nombreControles.titulo);
        }
      }
    }

    this.mostrarModalConfirmacion(mensajeConfirmacionGuardarComunicacion, (isConfirm: boolean) => {
      if (!isConfirm) {
        return;
      }

      this.mostrarProgreso();

      const datosComunicacion = this.getJsonElementoComunicacion();

      this.comunicacionService.registrarComunicacion(datosComunicacion)
        .then((result: any) => {
          this.ocultarProgreso();
          this.ResetRecaptcha = false;

          if (result.data === null) {
            this.toastr.warning('Se encontró un problema en el registro de la comunicación', '¡Error!');
            this.ResetRecaptcha = false;
            return;
          }

          if (!Funciones.EsNullVacioUndefined(result.data.mensajeError)) {
            this.mostrarModalInformativo('Error!', result.data.mensajeError);
            this.ResetRecaptcha = false;
            return;
          }

          if (result.data.id !== undefined) {
            sessionStorage.setItem('SesionRegistroPublico_CodigoComunicion', result.data.codigoComunicacion);
            sessionStorage.setItem('SesionRegistroPublico_VaRegistrarDT', datosComunicacion.VaRegistrarDocumentacionTecnica);
            const url = window.location.origin + "/" + environment.appPage + "/exito";
            window.location.href = url;
          }
        })
        .catch((error: any) => {
          this.mostrarModalError('Error Registrar Comunicacion: ', error.message);
          this.ResetRecaptcha = false;
          this.ocultarProgreso();
        });
    },
      this.language === "en" ? 'Yes' : 'Sí',
      'No'
    );

  }

  convertirArrayByte = (arrayBuffer: any) => {
    const d: Deferred<any> = new Deferred<any>();
    const reader = new FileReader();

    reader.onloadend = function (e) {
      const arrayBuffer = e.target!.result;
      const uint8Array = new Uint8Array(arrayBuffer as ArrayBuffer);
      const bytesArchivo = [].slice.call(uint8Array);
      d.resolve(bytesArchivo);
    };

    reader.readAsArrayBuffer(arrayBuffer);

    return d.promise;
  };

  changeLanguage(lang: string) {
    this.language = lang;
    /*if (lang !== this.i18NextService.language) {
      this.i18NextService.changeLanguage(lang).then(x => {
        this.updateState(lang);
        const url = window.location.origin + "/?lng=" + this.language + '&emp=' + this.idEmpresa;
        window.location.href = url;
        //document.location.reload();
      });
    }*/
  }

  private updateState(lang: string) {
    this.language = lang;

    if (this.language === 'es') {
      this.languageFlag = 'spain-bandera';
    }
    if (this.language === 'en') {
      this.languageFlag = 'eeuu-bandera';
    }
  }

  eventoVaRegistrarDocumentarion(event: any){
    this.SwitchVaRegistrarDocumentacion = event.checked;
    this.ItemsAdjuntos = [];
    this.ItemsProyecto = [];
    this.form.controls[this.nombreControles.proyecto].setValue('');
    this.form.controls[this.nombreControles.numeroSecuencia].setValue('');
    this.form.controls[this.nombreControles.titulo].setValue('');
    this.nombreArchivoCarta = "";
    this.nombreArchivoHRD = "";
    this.tieneCargadoCarta = false;
    this.tieneCargadoHRD = false;

    if(!this.SwitchVaRegistrarDocumentacion){
      this.form.controls[this.nombreControles.proyecto].clearValidators();
      this.form.controls[this.nombreControles.numeroSecuencia].clearValidators();      
      this.form.controls[this.nombreControles.titulo].clearValidators();
      this.form.controls[this.nombreControles.contactoRemitente].clearValidators();

      this.form.controls[this.nombreControles.proyecto].updateValueAndValidity();
      this.form.controls[this.nombreControles.numeroSecuencia].updateValueAndValidity();
      this.form.controls[this.nombreControles.titulo].updateValueAndValidity();
      this.form.controls[this.nombreControles.contactoRemitente].updateValueAndValidity();
    }
    else{
      this.form.controls[this.nombreControles.proyecto].validator = Validators.required;
      this.form.controls[this.nombreControles.numeroSecuencia].validator = Validators.required;
      this.form.controls[this.nombreControles.titulo].validator = Validators.required;
      this.form.controls[this.nombreControles.contactoRemitente].validator = Validators.required;

      this.mostrarProgreso();

      this.maestroDocumentoInternoService.listarProyectos(this.campo.idRemitenteExterno)
      .then((result: any) => 
      {
        if (result.data.length > 0) {
          for (const item of result.data) {
            this.ItemsProyecto.push(EProyecto.parseJsonBack(item));
          }
        }

        this.form.controls[this.nombreControles.proyecto].updateValueAndValidity();
        this.form.controls[this.nombreControles.numeroSecuencia].updateValueAndValidity();
        this.form.controls[this.nombreControles.titulo].updateValueAndValidity();
        this.form.controls[this.nombreControles.contactoRemitente].updateValueAndValidity();

        this.ocultarProgreso();
      });
    }
  }

  async OnFileUploadDocumentosAdjuntosTecnico(event: any, tipoDoc: string): Promise<any> {

    if (event.target.files.length > 0) {

      this.mostrarProgreso();

      const files = event.target.files;
      const listaArchivosRepetidos = [];
      const listaArchivosTamanoNoPermitidos = [];
      const listaArchivosExtensionesNoPermitidas = [];
      const listaArchivosContenidoErroneo = [];

      const fileName = files[0].name;
      const numeroDocumento = fileName.slice(0, fileName.lastIndexOf('.'));

      if(tipoDoc === 'Carta') {
        const resultado = await this.comunicacionService.validarExisteCarta(numeroDocumento).then();

        if(resultado.data){
          let mensaje = '';
          this.ocultarProgreso();

          if (this.language === "en") {
            mensaje = 'The selected letter is already registered in the system.';
          } else {
            mensaje = 'La CARTA seleccionada ya se encuentra registrado en el sistema.';
          }
          this.mostrarModalInformativo('¡Validación!', mensaje);
          $('#FileControlDocumentosAdjuntos' + tipoDoc).val('');          
          return;
        }
      }

      if(tipoDoc === 'HRD') {
        const resultado = await this.comunicacionService.validarExisteHRD(numeroDocumento).then();

        if(resultado.data){
          let mensaje = '';
          this.ocultarProgreso();

          if (this.language === "en") {
            mensaje = 'The selected HRD is already registered in the system.';
          } else {
            mensaje = 'El HRD seleccionado ya se encuentra registrado en el sistema.';
          }
          this.mostrarModalInformativo('¡Validación!', mensaje);
          $('#FileControlDocumentosAdjuntos' + tipoDoc).val('');          
          return;
        }
      }

      const proyectoId = this.getValorControlString(this.nombreControles.proyecto);
      const elementoProyecto = this.ItemsProyecto.filter(x => x.ID == proyectoId);
      const codigoProyecto = elementoProyecto.length > 0 ? elementoProyecto[0].Codigo: "";

      const listNumeroDocumento = numeroDocumento.split('-');
      
      if(listNumeroDocumento.length === 6){
        const codigoProyectoValidar = listNumeroDocumento[3] + '-' + listNumeroDocumento[4] + '-' + listNumeroDocumento[5];
      
        if(codigoProyecto != codigoProyectoValidar){
          let mensaje = '';
          this.ocultarProgreso();

          if (this.language === "en") {
            mensaje = 'The document does not correspond to the selected project.';
          } else {
            mensaje = 'El documento no corresponde al proyecto seleccionado.';
          }
          this.mostrarModalInformativo('¡Validación!', mensaje);
          $('#FileControlDocumentosAdjuntos' + tipoDoc).val('');          
          return;
        }
      }

      for (let i = 0; i < files.length; i++) {
        const archivo = files[i];

        const archivoRepetido = this.ItemsAdjuntos.filter(d => d.NombreArchivo === archivo.name);

        if (archivoRepetido.length > 0) {
          listaArchivosRepetidos.push(archivo.name);
        }

        if (!this.esArchivoExtensionValida(archivo.name)) {
          listaArchivosExtensionesNoPermitidas.push(archivo);
        }

        if (archivo.size > 209715200) {
          listaArchivosTamanoNoPermitidos.push(archivo.name);
        }

        if (await this.validarArchivoEncriptado(archivo).then()) {
          listaArchivosContenidoErroneo.push(archivo.name);
        }
      }

      if (listaArchivosRepetidos.length > 0) {
        const nombreArchivosRepetidos = listaArchivosRepetidos.join(', ');
        let mensaje = '';
        this.ocultarProgreso();

        if (this.language === "en") {
          mensaje = 'The following files are repeated: ' + nombreArchivosRepetidos;
        } else {
          mensaje = 'Los siguientes archivos están repetidos: ' + nombreArchivosRepetidos;
        }

        this.mostrarModalInformativo('¡Validación!', mensaje);

        $('#FileControlDocumentosAdjuntos' + tipoDoc).val('');        
        return;
      }

      if (listaArchivosContenidoErroneo.length > 0) {
        const nombreArchivosContenidoErroneo = listaArchivosContenidoErroneo.join(', ');
        let mensaje = '';
        this.ocultarProgreso();

        if (this.language === "en") {
          mensaje = 'The following encrypted PDF files are not allowed: ' + nombreArchivosContenidoErroneo;
        } else {
          mensaje = 'Los siguientes archivos PDF encriptados no estan permitidos: ' + nombreArchivosContenidoErroneo;
        }

        this.mostrarModalInformativo('¡Validación!', mensaje);

        $('#FileControlDocumentosAdjuntos' + tipoDoc).val('');        
        return;
      }

      if (listaArchivosExtensionesNoPermitidas.length > 0) {        
        let mensaje = '';
        this.ocultarProgreso();

        if (this.language === "en") {
          mensaje = 'Only files with the following extensions are allowed: .pdf,.xls,.xlsx,.doc,.docx,.ppt,.dwg,.jpg,.png,.mp4,.mp3,.rar,.zip';
        } else {
          mensaje = 'Sólo se permiten archivos con las siguientes extensiones: .pdf,.xls,.xlsx,.doc,.docx,.ppt,.dwg,.jpg,.png,.mp4,.mp3,.rar,.zip';
        }
        this.mostrarModalInformativo('¡Validación!', mensaje);

        $('#FileControlDocumentosAdjuntos' + tipoDoc).val('');
        return;
      }

      if (listaArchivosTamanoNoPermitidos.length > 0) {
        const nombreArchivosTamanoNoPermitidos = listaArchivosTamanoNoPermitidos.join(', ');
        let mensaje = '';
        this.ocultarProgreso();

        if (this.language === "en") {
          mensaje = 'The following files exceed the maximum size of 50 MB: ' + nombreArchivosTamanoNoPermitidos;
        } else {
          mensaje = 'Los siguientes archivos superan el peso máximo de 50 MB: ' + nombreArchivosTamanoNoPermitidos;
        }
        this.mostrarModalInformativo('¡Validación!', mensaje);

        $('#FileControlDocumentosAdjuntos' + tipoDoc).val('');
        return;
      }

      if(tipoDoc === 'Carta'){
        this.tieneCargadoCarta = true;
      }
      else{
        this.tieneCargadoHRD = true;
      }

      const elementoTipo = this.ItemsTipoDocumento.filter((elemento: EMaestro) => {
        return elemento.Title === tipoDoc;
      });

      let tipoDocumentoId = '';

      if (elementoTipo.length > 0) {
        tipoDocumentoId = elementoTipo[0].ID;
      }

      for (let i = 0; i < files.length; i++) {
        const resultByteArchivo = await this.convertirArrayByte(files[i]).then();
        const byteArchivo: any = resultByteArchivo;

        const datosArchivo: EComunicacionAdjuntoRegistrarDto = {
          EsPrincipal: tipoDoc === 'Carta',
          NombreArchivo: files[i].name,
          Codigo: files[i].name.slice(0, files[i].name.lastIndexOf('.')),
          Tipo: tipoDocumentoId,
          Descripcion: files[i].name.slice(0, files[i].name.lastIndexOf('.')),
          Archivo: byteArchivo
        };

        this.ItemsAdjuntos.push(datosArchivo);
        
        if(tipoDoc === 'Carta'){
          this.nombreArchivoCarta = files[i].name;
        }
        else{
          this.nombreArchivoHRD = files[i].name;
        } 
        this.ocultarProgreso();
      }

      $('#FileControlDocumentosAdjuntos' + tipoDoc).val('');

    }
  }

  EliminarAdjuntoTecnico(tipo: string){
    if(tipo === 'Carta'){
      this.tieneCargadoCarta = false;
    }
    else{
      this.tieneCargadoHRD = false;
    }

    const elementoTipo = this.ItemsTipoDocumento.filter((elemento: EMaestro) => {
      return elemento.Title === tipo;
    });
    const IdTipo = elementoTipo.length != 0 ? elementoTipo[0].ID: '0';

    this.ItemsAdjuntos = this.ItemsAdjuntos.filter(x => x.Tipo !== IdTipo.toString());
  }

  onChangeProyecto(event: any): void {
    this.disabledCarta = false;
    this.disabledHRD = false;
  }

}
